import { useCallback } from 'react'

import { useMetadata } from '@scoir/tracking'

import metadataToTrackedEvent from 'common/metadata-to-tracked-event'

export const useMetadataToTrackedEvent = (EventType) => {
  const [get] = useMetadata()
  return useCallback(
    (options) => {
      return metadataToTrackedEvent(get(), EventType, options)
    },
    [EventType, get],
  )
}
